var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"country-region-profile-nav"},[_c('countries-nav',{attrs:{"selectMultiple":!_vm.$store.state.covid19.is_enabled || this.countries.length > 0,"closeOnSelect":false,"countries":_vm.countries,"toggleable":false,"closed":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd5d57e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/navigation/PageSidebarNavigation/CountryRegionProfile.vue
// module id = 287
// module chunks = 0